/* Menu open / close */
export const menu = () => {
	document.addEventListener('DOMContentLoaded', function () {
		const menu = document.querySelector('.menu')
		const btn = document.querySelector('.burger__menu')
		const bar = document.querySelector('.burger__wrapper')
		btn.addEventListener('click', togglemenu)
           function togglemenu(){
            bar.classList.toggle('active-bar')
            menu.classList.toggle('drop-down')

			if (menu.classList.contains('drop-down')) {
                document.body.style.position = 'fixed'
				document.body.style.top = 0
			} else {
                document.body.style.position = ''
				document.body.style.top = null
			}
        } 
		})
}
/* Hidden menu on scroll */
export const menuScroll = () =>{
    document.addEventListener('DOMContentLoaded', function () {
        const header = document.querySelector('.header')
        let posInit = 0
        window.addEventListener('scroll', function(){
            const newPosY = window.pageYOffset - posInit
            if(newPosY > 0){
                header.classList.add('scrollY-nav')
                header.style.transition = '0.4s'
            }else{
                header.classList.remove('scrollY-nav')
            }
            if(scrollY > 0){
                header.classList.add('add-bg')
                header.style.transition = '0.4s'
            }else{
                header.classList.remove('add-bg')  
            }
            posInit = window.pageYOffset
        })
	})
}
